import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateGenderProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_GENDER,
    payload: {
      key: PROFILE_KEY.GENDER,
      value
    }
  })
}
